import { TokenPayload } from 'auth'
import axios from 'axios'
import dayjs from 'dayjs'
import Cookies from 'js-cookie'
import jwt_decode from 'jwt-decode'

import { handleRefreshTokenRequest } from '../../api/rest/refreshTokenRequest'
import { setTokenCookies } from '../../services/auth/auth'
import { Env, getEnv } from '../../utils/get-env'

export const axiosPublic = axios.create({
    baseURL: getEnv(Env.GATSBY_REST_API_URL),
})

export const axiosAuth = axios.create({
    baseURL: getEnv(Env.GATSBY_REST_API_URL),
})

axiosAuth.interceptors.request.use(async (req) => {
    const access_token = Cookies.get('access_token')

    if (access_token) {
        const decodedToken: TokenPayload = jwt_decode(access_token)
        const isExpired = dayjs.unix(decodedToken.exp).diff(dayjs()) < 1

        if (isExpired) {
            const response = await handleRefreshTokenRequest()
            setTokenCookies(response.data)
        }

        ;(req.headers ?? {}).Authorization = `Bearer ${Cookies.get(
            'access_token'
        )}`
        return req
    } else {
        return new Error('Cant find access token')
    }
})
